import { BaseError } from "@/domains/errors/kinds/BaseError";
import { JsonObject } from "@/domains/common/types";
import { AppErrorCode } from "@/domains/errors/constants";

export class ContentionError extends BaseError {
  constructor(info?: JsonObject) {
    super({
      code: AppErrorCode.CONTENTION,
      message: "Contention error",
      statusCode: 500,
      info,
    });
  }
}

export class LockingError extends BaseError {
  constructor(info?: JsonObject) {
    super({
      code: AppErrorCode.CONTENTION,
      message: `Failed to get lock.`,
      statusCode: 500,
      info,
    });
  }
}

export class AudioRecorderLockingError extends BaseError {
  constructor(info?: JsonObject) {
    super({
      code: AppErrorCode.CONTENTION,
      message: `Failed to get audio recorder lock.`,
      statusCode: 500,
      info,
    });
  }
}
